// ##############################
// // // Variables - Styles that are used on more than one component
// #############################

const drawerWidth = 260;

const drawerMiniWidth = 80;

const transition = {
  transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
};

const containerFluid = {
  paddingRight: "7px",
  paddingLeft: "7px",
  marginRight: "auto",
  marginLeft: "auto",
  "&:before,&:after": {
    display: "table",
    content: '" "'
  },
  "&:after": {
    clear: "both"
  }
};

const container = {
  paddingRight: "7px",
  paddingLeft: "7px",
  marginRight: "auto",
  marginLeft: "auto",
  "@media (min-width: 768px)": {
    width: "750px"
  },
  "@media (min-width: 992px)": {
    width: "970px"
  },
  "@media (min-width: 1200px)": {
    width: "1170px"
  },
  "&:before,&:after": {
    display: "table",
    content: '" "'
  },
  "&:after": {
    clear: "both"
  }
};

const boxShadow = {
  boxShadow:
    "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
};

const card = {
  display: "inline-block",
  position: "relative",
  width: "100%",
  margin: "25px 0",
  boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
  borderRadius: "6px",
  color: "rgba(0, 0, 0, 0.87)",
  background: "#fff"
};

const defaultFont = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: "300",
  lineHeight: "1.5em"
};

//wisene colors:
const L0 = "rgb(49,196,52)";
const L1 = "rgb(125, 242, 0)";
const L2 = "rgb(255, 225, 28)";
const L3 = "rgb(255, 153, 0)";
const L4 = "rgb(255,0,0)";

const iconShape = {
  float: "left",
  padding: "15px",
  marginTop: "-20px",
  marginRight: "15px",
  borderRadius: "3px"
};

//wisene:
const L0BoxShadow = {
  boxShadow:
    "0 12px 20px -10px rgba(100, 100, 100, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(110,110,110, 0.2)"
};
const L1BoxShadow = {
  boxShadow:
    "0 12px 20px -10px rgba(100, 100, 100, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(110,110,110, 0.2)"
};
const L2BoxShadow = {
  boxShadow:
    "0 12px 20px -10px rgba(100, 100, 100, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(110,110,110, 0.2)"
};
const L3BoxShadow = {
  boxShadow:
    "0 12px 20px -10px rgba(100, 100, 100, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(110,110,110, 0.2)"
};
const L4BoxShadow = {
  boxShadow:
    "0 12px 20px -10px rgba(100, 100, 100, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(110,110,110, 0.2)"
};
const selectedItemBoxShadow = {
  boxShadow:
    "0 12px 20px -10px rgba(100, 100, 100, 0.28), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(110,110,110, 0.2)"
}

//wisene
const L0CardHeader = {
  background: "linear-gradient(60deg, #7df200, #31b800)",
  ...iconShape,
  ...L0BoxShadow
};
const L1CardHeader = {
  background: "linear-gradient(60deg, rgb(220, 255, 0), rgb(125, 242, 0))",
  ...iconShape,
  ...L1BoxShadow
};
const L2CardHeader = {
  background: "linear-gradient(60deg, rgb(255, 255, 128), rgb(255, 225, 28))",
  ...iconShape,
  ...L2BoxShadow
};
const L3CardHeader = {
  background: "linear-gradient(60deg, rgb(255, 234, 0), rgb(255, 153, 0))",
  ...iconShape,
  ...L3BoxShadow
};
const L4CardHeader = {
  background: "linear-gradient(60deg, rgb(255, 140, 140), rgb(255, 0, 0))",
  ...iconShape,
  ...L4BoxShadow
};
const obstructedCardHeader = {
  background: "linear-gradient(60deg, #ab30db, #41007d)",
  ...iconShape,
  ...L4BoxShadow
};

const W2NonOperationalCardHeader = {
  background: "linear-gradient(60deg, rgb(150, 150, 150), rgb(60, 60, 60))",
  ...iconShape,
  ...L4BoxShadow
}

const inactiveCardHeader = {
  background: "linear-gradient(60deg, rgb(200, 200, 200), rgb(100, 100, 100))",
  ...iconShape,
  ...L4BoxShadow
}

const cardActions = {
  margin: "0 20px 10px",
  paddingTop: "10px",
  borderTop: "1px solid #eeeeee",
  height: "auto",
  ...defaultFont
};

const cardHeader = {
  margin: "-20px 15px 0",
  borderRadius: "3px",
  padding: "7px"
};

const defaultBoxShadow = {
  border: "0",
  borderRadius: "3px",
  boxShadow:
    "0 10px 20px -12px rgba(0, 0, 0, 0.42), 0 3px 20px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  padding: "10px 0",
  transition: "all 150ms ease 0s"
};

const tooltip = {
  padding: "10px 15px",
  minWidth: "130px",
  color: "#FFFFFF",
  lineHeight: "1.7em",
  background: "rgba(85,85,85,0.9)",
  border: "none",
  borderRadius: "3px",
  opacity: "1!important",
  boxShadow:
    "0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)",
  maxWidth: "200px",
  textAlign: "center",
  fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "400",
  textShadow: "none",
  textTransform: "none",
  letterSpacing: "normal",
  wordBreak: "normal",
  wordSpacing: "normal",
  wordWrap: "normal",
  whiteSpace: "normal",
  lineBreak: "auto"
};

const title = {
  color: "#3C4858",
  textDecoration: "none",
  fontWeight: "300",
  marginTop: "30px",
  marginBottom: "25px",
  minHeight: "32px",
  fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  "& small": {
    color: "#777",
    fontSize: "65%",
    fontWeight: "400",
    lineHeight: "1"
  }
};

const cardTitle = {
  ...title,
  marginTop: "0",
  marginBottom: "3px",
  minHeight: "auto",
  "& a": {
    ...title,
    marginTop: ".625rem",
    marginBottom: "0.75rem",
    minHeight: "auto"
  }
};

const cardSubtitle = {
  marginTop: "-.375rem"
};

const cardLink = {
  "& + $cardLink": {
    marginLeft: "1.25rem"
  }
};

export {
  //variables
  drawerWidth,
  drawerMiniWidth,
  transition,
  container,
  containerFluid,
  boxShadow,
  card,
  defaultFont,
  cardActions,
  cardHeader,
  defaultBoxShadow,
  tooltip,
  title,
  cardTitle,
  cardSubtitle,
  cardLink,
  //wisene
  L0BoxShadow,
  L1BoxShadow,
  L2BoxShadow,
  L3BoxShadow,
  L4BoxShadow,
  selectedItemBoxShadow,
  L0,
  L1,
  L2,
  L3,
  L4,
  L0CardHeader,
  L1CardHeader,
  L2CardHeader,
  L3CardHeader,
  L4CardHeader,
  obstructedCardHeader,
  W2NonOperationalCardHeader,
  inactiveCardHeader
};
